var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Human } from '@hn-ui/icons';
import { isAssignmentCell } from '../tableConfig';
var ScCell = styled.div.withConfig({ displayName: "ScCell", componentId: "sc-20dsum" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n\n  svg {\n    margin-left: 5px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n\n  svg {\n    margin-left: 5px;\n  }\n"])));
export var StudentsStrugglingCell = function (_a) {
    var row = _a.row;
    if (!isAssignmentCell(row.original))
        return null;
    var studentsStruggling = row.original.studentsStruggling;
    return (_jsx(ScCell, { children: studentsStruggling ? (_jsxs(_Fragment, { children: [studentsStruggling, " ", _jsx(Human, { size: 16, color: 'red50' }, void 0)] }, void 0)) : ('–') }, void 0));
};
var templateObject_1;
